import { initialCheckoutState } from '../checkout-state.js';
export function hostedEligibilityRecovery(discovery, method, authenticationRequested) {
    if (discovery.status === 'connectionRequired')
        return authenticationRequested &&
            discovery.authenticationAvailable &&
            discovery.authenticationReason !== 'account_mismatch'
            ? 'connect_requested'
            : 'connection_required';
    const state = initialCheckoutState(null, discovery, method, authenticationRequested, true);
    switch (state) {
        case 'customer_verification':
            return 'customer_verification_required';
        case 'verification':
            return 'contacts_required';
        case 'terms':
            return 'terms_required';
        case 'connect':
            return 'connect_requested';
        case 'connection_required':
            return 'connection_required';
        case 'unavailable':
            return 'connection_unavailable';
        default:
            return null;
    }
}
